"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @classdesc A Media represents a metadata information for the media upload
 * @property {String} sid - The server-assigned unique identifier for Media
 * @property {String} serviceSid - Service instance id which Media belongs/uploaded to
 * @property {Date} dateCreated - When the Media was created
 * @property {Date} dateUpdated - When the Media was updated
 * @property {Number} size - Size of media, bytes
 * @property {String} contentType - content type of media
 * @property {String} fileName - file name, if present, null otherwise
 */

var Media =
/*#__PURE__*/
function () {
  function Media(config, network, data) {
    _classCallCheck(this, Media);

    this.config = config;
    this.network = network;

    this._update(data);
  }

  _createClass(Media, [{
    key: "getContentUrl",

    /**
     * Returns direct content URL to uploaded binary
     * @public
     * @returns {Promise<string>}
     */
    value: function () {
      var _getContentUrl = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.network.get("".concat(this.config.baseUrl, "/").concat(this.sid));

              case 2:
                response = _context.sent;

                this._update(response.body);

                return _context.abrupt("return", Promise.resolve(this.state.contentDirectUrl));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getContentUrl() {
        return _getContentUrl.apply(this, arguments);
      }

      return getContentUrl;
    }()
  }, {
    key: "_update",
    value: function _update(data) {
      this.state = {
        sid: data.sid,
        serviceSid: data.service_sid,
        channelSid: data.channel_sid,
        messageSid: data.message_sid,
        dateCreated: data.date_created ? new Date(data.date_created) : null,
        dateUpdated: data.date_updated ? new Date(data.date_updated) : null,
        size: data.size,
        contentType: data.content_type,
        url: data.url,
        contentUrl: data.links.content,
        contentDirectUrl: data.links.content_direct_temporary,
        filename: data.filename ? data.filename : null
      };
    }
  }, {
    key: "sid",
    get: function get() {
      return this.state.sid;
    }
  }, {
    key: "serviceSid",
    get: function get() {
      return this.state.serviceSid;
    }
  }, {
    key: "dateCreated",
    get: function get() {
      return this.state.dateCreated;
    }
  }, {
    key: "dateUpdated",
    get: function get() {
      return this.state.dateUpdated;
    }
  }, {
    key: "contentType",
    get: function get() {
      return this.state.contentType;
    }
  }, {
    key: "size",
    get: function get() {
      return this.state.size;
    }
  }, {
    key: "fileName",
    get: function get() {
      return this.state.filename;
    }
  }]);

  return Media;
}();

exports.Media = Media;